"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var CookieStrategy_1 = require("../CookieStrategy");
var ExpressJsCookies = /** @class */ (function (_super) {
    __extends(ExpressJsCookies, _super);
    function ExpressJsCookies(cookieDomain, req, res) {
        var _this = _super.call(this, cookieDomain, req.hostname) || this;
        _this.request = req;
        _this.response = res;
        return _this;
    }
    ExpressJsCookies.prototype.Get = function (name) {
        return this.request.cookies[name];
    };
    ExpressJsCookies.prototype.Set = function (name, value, expiryHours) {
        var sameSite = this.SAMESITES[name.toLowerCase()] || 'Lax';
        var cookieAttributes = {
            domain: this.COOKIE_DOMAIN,
            expires: this._getExpireDate(expiryHours),
            path: "/",
            sameSite: sameSite,
            secure: sameSite === 'None'
        };
        this.response.cookie(name, value, cookieAttributes);
    };
    return ExpressJsCookies;
}(CookieStrategy_1.default));
exports.default = ExpressJsCookies;
//# sourceMappingURL=ExpressJsCookies.js.map